import React, { useContext } from "react";
import Navbar from "./select-components/navbar-select";
import PageHeader from "./global-components/page-header";
import Mission from "./section-components/mission";
import AboutUs from "./section-components/about-us";
import ServiceTwo from "./section-components/service-two";
import WhyChooseUs from "./section-components/why-choose-us";
import Team from "./section-components/team";
import Client from "./section-components/client";
import Footer from "./select-components/footer-select";
import EmpresaContext from "../context";

const About = () => {
  let context = useContext(EmpresaContext);
  return (
    <div>
      <Navbar />
      <PageHeader
        backgroundImage={
          context.info_gen["image-header-pages"] ||
          context.banner[1] ||
          context.banner[0] ||
          "#"
        }
        headertitle={
          context.info_gen &&
          (context.info_gen.header_sobre
            ? context.info_gen.header_sobre
            : `Sobre ${context.nome_fantasia || context.nome || "nós"}`)
        }
      />
      <Mission />
      {!context.ocultar_sobre && <AboutUs />}
      {
        //<ServiceTwo />
      }
      {!context.ocultar_equipe && <Team />}
      <Client />
      <Footer />
    </div>
  );
};

export default About;
